<!-- ══════════════════════════════════════════════════════════════════════════
     USUARIOS DEL PORTAL DE UN COMERCIO — pantalla propia.

     🔴 REDISEÑO 2026-09-20, aprobado por Juan: *«demasiada caja, demasiado
     contenido, la vista se pierde»*.

     Era la solapa `usuarios` de la ficha, y adentro tenía DOS SUB-SOLAPAS:
     había que elegir TRES veces —la ficha, la solapa, la sub-solapa— para
     llegar a una lista de nueve filas. Cada sub-solapa con su buscador y su
     paginación, y una tapando a la otra.

     Lo que salió, y por qué:
       · LAS SUB-SOLAPAS. Las dos listas van una debajo de la otra: con ruta
         propia ya no hay ni encabezado de ficha ni fila de pestañas arriba, que
         era lo que las empujaba fuera de la pantalla. El porqué completo está
         en el comentario de cabecera del componente.
       · el subtítulo de la tarjeta y los dos renglones de ayuda bajo cada
         sub-solapa («Gente del comercio. Entran a mirar sus ventas…»): el
         rótulo de la sección ya lo dice.
       · el aviso permanente de las cajas («Todavía no se pueden listar las
         cajas en este ambiente») — un aviso que está SIEMPRE deja de ser un
         aviso. Ahora es uno de los tres estados vacíos de la sección.
       · la tarjeta que envolvía todo.

     Los tres estados de las cajas se conservan, que es lo que ese aviso
     protegía: hay cajas / no hay cajas / NO SE PUEDE SABER si hay cajas
     (mientras el servidor no mande `tipo`). Afirmar «no tiene cajas» cuando no
     se pueden ver sería una pantalla mintiendo con cara de estar bien.
     ══════════════════════════════════════════════════════════════════════════ -->
<!-- 🔴 SIN MIGA, SIN TÍTULO Y SIN ENVOLTORIO DE PÁGINA — 2026-09-20.
     Esta pantalla es una RUTA HIJA de la ficha del comercio y se dibuja dentro
     de su `<router-outlet>`. El padre ya pone la miga, el nombre del comercio,
     su estado, la tira del portal y la barra de pestañas: repetirlos acá los
     mostraba DOS VECES, uno debajo del otro, y además `kb-page` anidado dentro
     de `kb-page` duplicaba el relleno y el ancho máximo.
     Lo que sí queda acá son las ACCIONES de esta pantalla. -->
<div class="space-y-8">


  <!-- ── Encabezado ─────────────────────────────────────────────────────────── -->
  <!-- 🔴 LAS ACCIONES, A LA DERECHA Y CON AIRE. Juan, 2026-09-20: «el botón,
       cuando navegas entre pestañas, está a la izquierda y pegado».
       Era `kb-page-header`, que reparte título a la izquierda y acciones a la
       derecha con `justify-between`. Al sacarle el título —lo pone el padre—
       quedó UN SOLO hijo, y `justify-between` con uno solo lo manda al borde
       izquierdo. Acá se alinea a la derecha a propósito, y `pt-1` lo despega de
       la barra de pestañas de arriba. -->
  <div class="flex flex-wrap items-center justify-end gap-2 pt-2">

    <div class="flex shrink-0 items-center gap-2" *ngIf="!cargando && !noEncontrado">
      <button type="button" class="kb-btn kb-btn-primary" (click)="irAAltaUsuario()">
        <i class="fas fa-user-plus" aria-hidden="true"></i>Agregar un usuario
      </button>
    </div>
  </div>

  <!-- ── Cargando ─────────────────────────────────────────────────────────────
       El esqueleto conserva la FORMA: dos bloques de lista, uno debajo del otro. -->
  <div *ngIf="cargando || cargandoUsuarios" class="space-y-8" aria-live="polite" aria-busy="true">
    <div class="kb-skeleton h-14 w-full rounded-lg"></div>
    <div class="space-y-4">
      <div class="kb-skeleton h-3 w-32"></div>
      <div class="kb-skeleton h-48 w-full"></div>
    </div>
    <div class="space-y-4">
      <div class="kb-skeleton h-3 w-32"></div>
      <div class="kb-skeleton h-48 w-full"></div>
    </div>
  </div>

  <!-- ── No existe el comercio ──────────────────────────────────────────────── -->
  <div class="kb-empty" *ngIf="!cargando && noEncontrado">
    <span class="kb-empty-icono"><i class="fas fa-store-slash" aria-hidden="true"></i></span>
    <p class="kb-empty-titulo">No encontramos el comercio «{{ codigo }}»</p>
    <p class="kb-empty-texto">Puede que el código esté mal escrito.</p>
    <a class="kb-btn kb-btn-outline mt-4" [routerLink]="['/console/merchants']">
      <i class="fas fa-arrow-left" aria-hidden="true"></i>Volver a comercios
    </a>
  </div>

  <div class="space-y-10" *ngIf="!cargando && !cargandoUsuarios && !noEncontrado">

    <!-- ══ LA CINTA — una sola, y es la decisión de la pantalla ══════════════
         🔴 El estado que antes era invisible: un comercio sin usuarios activos
         no puede entrar a su portal y nada lo decía. -->
    <div class="kb-cinta" *ngIf="!hayUsuarios">
      <i class="fas fa-exclamation-triangle kb-cinta-icono" aria-hidden="true"></i>
      <p class="m-0">
        <strong class="font-semibold">Este comercio no puede entrar a su portal.</strong>
        Todavía no tiene ningún usuario, así que no hay forma de que vea sus ventas ni sus
        liquidaciones. Se le crea uno con «Agregar un usuario».
      </p>
    </div>

    <div class="kb-cinta" *ngIf="hayUsuarios && sinUsuariosActivos">
      <i class="fas fa-exclamation-triangle kb-cinta-icono" aria-hidden="true"></i>
      <p class="m-0">
        <strong class="font-semibold">Este comercio no puede entrar a su portal.</strong>
        Tiene usuarios, pero ninguno está activo. Vuelve a activar el que corresponda desde su
        fila, o agrega otro.
      </p>
    </div>

    <!-- ══════════════ PERSONAS — primero: son pocas y son las que se buscan ══
         Gente del comercio que entra a mirar sus ventas y sus liquidaciones. -->
    <section class="kb-tarjeta">
      <div class="kb-tarjeta-cab">
        <h2 class="text-base font-semibold leading-none">
          Personas <span class="tabular-nums">({{ personas.length }})</span>
        </h2>
      </div>
      <div class="kb-tarjeta-cuerpo">
      <div class="kb-toolbar" *ngIf="personas.length">
        <div class="kb-toolbar-grupo min-w-0 flex-1">
          <!-- 2026-09-24: con ancho propio; dentro del grupo flexible se encogía a nada. -->
          <div class="kb-buscador min-w-[16rem] flex-1 sm:max-w-md">
            <i class="fas fa-search kb-buscador-icono" aria-hidden="true"></i>
            <label class="sr-only" for="buscarPersona">Buscar una persona</label>
            <input id="buscarPersona" type="text" class="kb-input kb-input-icono w-full"
                   placeholder="Buscar por nombre, usuario o correo" name="buscarPersona"
                   [(ngModel)]="busquedaPersona" (ngModelChange)="alEscribir('persona')">
          </div>
          <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm"
                  *ngIf="busquedaPersona" (click)="limpiarBusquedaPersona()">
            <i class="fas fa-times" aria-hidden="true"></i>Limpiar la búsqueda
          </button>
        </div>
        <p class="kb-toolbar-conteo">
          <span class="tabular-nums">{{ personasFiltradas.length }}</span>
          {{ personasFiltradas.length === 1 ? 'persona' : 'personas' }}
        </p>
      </div>

      <div class="kb-tabla-plana" *ngIf="personasPaginadas.length">
        <table class="kb-table">
          <thead class="kb-thead">
            <tr>
              <th class="kb-th">Usuario</th>
              <th class="kb-th">Nombre</th>
              <th class="kb-th">Correo</th>
              <th class="kb-th">Rol</th>
              <th class="kb-th">Estado</th>
              <th class="kb-th kb-th-acciones">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr class="kb-tr" *ngFor="let u of personasPaginadas; trackBy: porId"
                [ngClass]="{'kb-tr-atenuada': !u.status}">
              <td class="kb-td kb-td-mono">{{ u.username }}</td>
              <td class="kb-td">{{ u.name }} {{ u.lastName }}</td>
              <td class="kb-td kb-td-sub">{{ u.email || '—' }}</td>
              <!-- 🔴 El papel que RIGE, en palabras: el mismo con el que la persona entra al portal. -->
              <td class="kb-td">
                <span class="kb-badge kb-badge-neutro" *ngIf="rolEnPalabras(u) as r; else sinRol">{{ r }}</span>
                <ng-template #sinRol><span class="text-muted-foreground">—</span></ng-template>
              </td>
              <td class="kb-td">
                <span class="kb-badge" [ngClass]="u.status ? 'kb-badge-exito' : 'kb-badge-neutro'">
                  {{ u.status ? 'Activo' : 'Inactivo' }}
                </span>
              </td>
              <td class="kb-td-acciones">
                <div class="kb-acciones-grupo">
                  <button type="button" class="kb-btn kb-btn-outline kb-btn-icon"
                          [title]="'Reponer la clave de ' + u.username"
                          [attr.aria-label]="'Reponer la clave de ' + u.username"
                          (click)="reponerClave(u)">
                    <i class="fas fa-key" aria-hidden="true"></i>
                  </button>
                  <button type="button" class="kb-btn kb-btn-icon"
                          [ngClass]="u.status ? 'kb-btn-danger' : 'kb-btn-outline'"
                          [title]="(u.status ? 'Desactivar a ' : 'Activar a ') + u.username"
                          [attr.aria-label]="(u.status ? 'Desactivar a ' : 'Activar a ') + u.username"
                          (click)="alternarUsuario(u)">
                    <i class="fas" [ngClass]="u.status ? 'fa-user-slash' : 'fa-user-check'"
                       aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Los dos estados vacíos: no hay ninguna, o ninguna coincide. -->
      <div class="kb-empty" *ngIf="!personas.length">
        <span class="kb-empty-icono"><i class="fas fa-users" aria-hidden="true"></i></span>
        <p class="kb-empty-titulo">Este comercio no tiene usuarios de personas</p>
        <p class="kb-empty-texto">
          Sin una persona, nadie del comercio puede entrar a mirar sus ventas ni sus
          liquidaciones: las cajas sólo cobran.
        </p>
      </div>

      <div class="kb-empty" *ngIf="personas.length && !personasFiltradas.length">
        <span class="kb-empty-icono"><i class="fas fa-search" aria-hidden="true"></i></span>
        <p class="kb-empty-titulo">Ninguna persona coincide con «{{ busquedaPersona }}»</p>
        <button type="button" class="kb-btn kb-btn-outline mt-4" (click)="limpiarBusquedaPersona()">
          Limpiar la búsqueda
        </button>
      </div>

      <div class="kb-pager" *ngIf="totalPaginasPersona > 1">
        <p class="kb-barra-nota">
          Página <span class="tabular-nums">{{ paginaPersona }}</span> de
          <span class="tabular-nums">{{ totalPaginasPersona }}</span>
        </p>
        <div class="flex items-center gap-1">
          <button type="button" class="kb-btn kb-btn-outline kb-btn-icon"
                  [disabled]="paginaPersona === 1" (click)="irAPaginaPersona(paginaPersona - 1)"
                  aria-label="Página anterior de personas">
            <i class="fas fa-chevron-left" aria-hidden="true"></i>
          </button>
          <button type="button" class="kb-btn kb-btn-outline kb-btn-icon"
                  [disabled]="paginaPersona === totalPaginasPersona"
                  (click)="irAPaginaPersona(paginaPersona + 1)"
                  aria-label="Página siguiente de personas">
            <i class="fas fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      </div>
    </section>

    <!-- ══════════════ CAJAS — segundo: es la lista que crece ════════════════
         Puestos de cobro. Cada uno vive en una tienda y se abre con su propio
         usuario. -->
    <section class="kb-tarjeta">
      <div class="kb-tarjeta-cab">
        <h2 class="text-base font-semibold leading-none">
          Cajas <span class="tabular-nums" *ngIf="tipoDeUsuarioDisponible">({{ cajas.length }})</span>
        </h2>
      </div>
      <div class="kb-tarjeta-cuerpo">
      <!-- 📍 El filtro por tienda es la pregunta que se hace de verdad: «¿qué
           cajas tiene Catia?». Por eso va primero, antes del buscador libre. -->
      <div class="kb-toolbar" *ngIf="cajas.length">
        <div class="kb-toolbar-grupo min-w-0 flex-1">
          <div class="kb-select-envoltorio">
            <label class="sr-only" for="filtroTienda">Filtrar las cajas por tienda</label>
            <select id="filtroTienda" class="kb-select" name="filtroTienda"
                    [(ngModel)]="filtroTiendaCaja" (ngModelChange)="alFiltrarPorTienda()">
              <option value="">Todas las tiendas</option>
              <option *ngFor="let t of tiendasParaFiltrar" [value]="t.code">
                {{ t.name || t.short_name || t.code }}
              </option>
            </select>
            <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
          </div>
          <!-- 2026-09-24: con ancho propio; dentro del grupo flexible se encogía a nada. -->
          <div class="kb-buscador min-w-[16rem] flex-1 sm:max-w-md">
            <i class="fas fa-search kb-buscador-icono" aria-hidden="true"></i>
            <label class="sr-only" for="buscarCaja">Buscar una caja</label>
            <input id="buscarCaja" type="text" class="kb-input kb-input-icono w-full"
                   placeholder="Buscar por usuario o número" name="buscarCaja"
                   [(ngModel)]="busquedaCaja" (ngModelChange)="alEscribir('caja')">
          </div>
          <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm"
                  *ngIf="hayFiltroCaja" (click)="limpiarFiltrosCaja()">
            <i class="fas fa-times" aria-hidden="true"></i>Quitar los filtros
          </button>
        </div>
        <p class="kb-toolbar-conteo">
          <span class="tabular-nums">{{ cajasFiltradas.length }}</span>
          {{ cajasFiltradas.length === 1 ? 'caja' : 'cajas' }}
        </p>
      </div>

      <div class="kb-tabla-plana" *ngIf="cajasPaginadas.length">
        <table class="kb-table">
          <thead class="kb-thead">
            <tr>
              <th class="kb-th">Usuario</th>
              <th class="kb-th">Tienda</th>
              <th class="kb-th kb-th-num">Caja</th>
              <th class="kb-th">Estado</th>
              <th class="kb-th kb-th-acciones">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr class="kb-tr" *ngFor="let u of cajasPaginadas; trackBy: porId"
                [ngClass]="{'kb-tr-atenuada': !u.status}">
              <td class="kb-td kb-td-mono">{{ u.username }}</td>
              <td class="kb-td">
                <span class="kb-td-titulo">{{ nombreTienda(u.shop) }}</span>
                <p class="kb-td-sub font-mono" *ngIf="u.shop">{{ u.shop }}</p>
              </td>
              <td class="kb-td kb-td-num tabular-nums">{{ numeroCaja(u) }}</td>
              <td class="kb-td">
                <span class="kb-badge" [ngClass]="u.status ? 'kb-badge-exito' : 'kb-badge-neutro'">
                  {{ u.status ? 'Activa' : 'Inactiva' }}
                </span>
              </td>
              <td class="kb-td-acciones">
                <div class="kb-acciones-grupo">
                  <button type="button" class="kb-btn kb-btn-outline kb-btn-icon"
                          [title]="'Reponer la clave de ' + u.username"
                          [attr.aria-label]="'Reponer la clave de ' + u.username"
                          (click)="reponerClave(u)">
                    <i class="fas fa-key" aria-hidden="true"></i>
                  </button>
                  <button type="button" class="kb-btn kb-btn-icon"
                          [ngClass]="u.status ? 'kb-btn-danger' : 'kb-btn-outline'"
                          [title]="(u.status ? 'Desactivar la caja ' : 'Activar la caja ') + u.username"
                          [attr.aria-label]="(u.status ? 'Desactivar la caja ' : 'Activar la caja ') + u.username"
                          (click)="alternarUsuario(u)">
                    <i class="fas" [ngClass]="u.status ? 'fa-user-slash' : 'fa-user-check'"
                       aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 🔴 TRES estados, no dos. Mientras el servidor no mande `tipo`, este
           cero no dice «no hay cajas»: dice «no se puede saber». El aviso
           permanente que decía esto se convirtió en este estado vacío. -->
      <div class="kb-empty" *ngIf="!cajas.length && !tipoDeUsuarioDisponible">
        <span class="kb-empty-icono"><i class="fas fa-question-circle" aria-hidden="true"></i></span>
        <p class="kb-empty-titulo">No se puede saber qué cajas tiene este comercio</p>
        <p class="kb-empty-texto">
          Este ambiente todavía no distingue las cajas de las personas, así que todos los usuarios
          figuran arriba. No quiere decir que no tenga cajas: quiere decir que no se pueden separar.
        </p>
      </div>

      <div class="kb-empty" *ngIf="!cajas.length && tipoDeUsuarioDisponible">
        <span class="kb-empty-icono"><i class="fas fa-cash-register" aria-hidden="true"></i></span>
        <p class="kb-empty-titulo">Este comercio todavía no tiene cajas con usuario</p>
        <p class="kb-empty-texto">
          Cada puesto de cobro se abre con su propio usuario. Se dan de alta con
          «Agregar un usuario».
        </p>
      </div>

      <div class="kb-empty" *ngIf="cajas.length && !cajasFiltradas.length">
        <span class="kb-empty-icono"><i class="fas fa-filter" aria-hidden="true"></i></span>
        <p class="kb-empty-titulo">Ninguna caja coincide con este filtro</p>
        <p class="kb-empty-texto" *ngIf="filtroTiendaCaja">
          {{ nombreTienda(filtroTiendaCaja) }} no tiene ninguna caja con usuario.
        </p>
        <button type="button" class="kb-btn kb-btn-outline mt-4" (click)="limpiarFiltrosCaja()">
          Quitar los filtros
        </button>
      </div>

      <div class="kb-pager" *ngIf="totalPaginasCaja > 1">
        <p class="kb-barra-nota">
          Página <span class="tabular-nums">{{ paginaCaja }}</span> de
          <span class="tabular-nums">{{ totalPaginasCaja }}</span>
        </p>
        <div class="flex items-center gap-1">
          <button type="button" class="kb-btn kb-btn-outline kb-btn-icon"
                  [disabled]="paginaCaja === 1" (click)="irAPaginaCaja(paginaCaja - 1)"
                  aria-label="Página anterior de cajas">
            <i class="fas fa-chevron-left" aria-hidden="true"></i>
          </button>
          <button type="button" class="kb-btn kb-btn-outline kb-btn-icon"
                  [disabled]="paginaCaja === totalPaginasCaja"
                  (click)="irAPaginaCaja(paginaCaja + 1)"
                  aria-label="Página siguiente de cajas">
            <i class="fas fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      </div>
    </section>

    <!-- ── El pie: por qué no hay un botón de borrar ────────────────────────── -->
    <div class="border-t border-border pt-5">
      <p class="m-0 max-w-3xl text-sm text-muted-foreground">
        Los usuarios se desactivan, no se borran: uno que ya entró dejó rastro, y borrarlo deja
        ese rastro apuntando a alguien que no existe.
      </p>
    </div>

  </div>
</div>
